import { Injectable } from "@angular/core";
import { UserModel } from '../models/user.model';

@Injectable()
export class UserStore {

    private storeKey: string = 'zefiro.pocket.app.user.store';
    public data: UserModel = new UserModel();

    UserStore(){
        this.load();
    }

    load(): void {
        let str: string = localStorage.getItem(this.storeKey);

        if (str)
            this.data = JSON.parse(str);
    }

    save() {
        localStorage.setItem(this.storeKey, JSON.stringify(this.data));
    }
}


// WEBPACK FOOTER //
// ./src/stores/user.store.ts